import type { LiveInstantBook, LiveInstantBookState } from 'state/secondaryMarket/live/instantBook/instantBook.models';
import type { AppState } from 'state/state.model';

function selectLiveInstantBookState(state: AppState): LiveInstantBookState {
  return state.secondaryMarket.live.instantBook;
}

export function getLiveInstantBook(appState: AppState, orderId: string): LiveInstantBook | undefined {
  const state = selectLiveInstantBookState(appState);
  return state[orderId];
}
